import React, { useState, useCallback, useMemo, useEffect, useRef, useLayoutEffect } from 'react'

import './styles.module.css'
import PagedownEditor from './Editor';

const VenusMarkdown = (props: any) => {

  const {
    onBlur = () => { },
    onFocus = () => { },
    onMouseEnter = () => { },
    onMouseLeave = () => { },
    value = '',
    onChange = () => { },
    requestProps = {},
    height = "300px",
    required = false,
    onKeyDown = () => { },
    disabled = false,
    useV2EmbedPicker,
    placeholder = 'Write some markdown...',
    uid = null,
    customChooseFromAssetsModal,
    openAMV2UploadTarget
  } = props;

  return (
    <div className={'cs_markdown'} >
      <PagedownEditor
        onUpdate={onChange}
        defaultValue={value}
        requestProps={requestProps}
        disabled={disabled}
        onFocus={onFocus}
        useV2EmbedPicker={useV2EmbedPicker}
        customChooseFromAssetsModal={customChooseFromAssetsModal}
        openAMV2UploadTarget={openAMV2UploadTarget}
        {...props}
      />
    </div >
  )
}

export default VenusMarkdown
